import RAGImg from "../images/RAG-Development.jpg";
import DeepLearningImg from "../images/DeepLearning.jpg";
import UniAccoHomePage from "../images/UniAccoHomePage.png";
import UniAccoListing from "../images/UniAccoListing.png";
import UniAccoPropertyDets from "../images/UniAccoPropertyDets.png";
import CRMListingPage from "../images/CRMListingPage.png";
import CRMDashboard from "../images/CRMDashboard.png";
import CRMConversion from "../images/CRMConversion.png";
import ManageExtension from "../images/ManageExtension.png";
import ExtensionUse from "../images/ExtensionUse.png";
import ExtensionWindow from "../images/ExtensionWindow.png";
import GeneratorImage from "../images/GeneratorImage.webp";
import GANImage1 from "../images/GANImage1.gif";
import GANImage2 from "../images/GANImage2.gif";
import GVwalaTechImg from "../images/GVwalaTechImg.png";
import GVwalaLoginImg from "../images/GVwalaLoginImg.png";
import GVwalaHomeImg from "../images/GVwalaHomeImg.png";
import CleansweepPoster from "../images/CleansweepPoster.jpg";
import CleansweepImg from "../images/CleansweepImg.jpg";
import CleansweepTopImg from "../images/CleansweepTopImg.jpg";
import HandmadeWithLoveLogin from "../images/HandmadeWithLoveLogin.png";
import HandmadeWithLoveListing from "../images/HandmadeWithLoveListing.png";

export const singleProjectData = [
  {
    ProjectHeader: {
      title: "Personalized Learning Tutor",
      tags: "AI / Agentic RAG",
    },
    ProjectImages: [
      {
        id: 1,
        title: "Personalized Learning Tutor",
        img: RAGImg,
      },
    ],
    ProjectInfo: {
      ClientHeading: "Project Type",
      CompanyInfo: [
        {
          id: 1,
          title: "Name",
          details: "Personalized Learning Tutor",
        },
        {
          id: 2,
          title: "Services",
          details: "Agentic RAG tutoring platform",
        },
        {
          id: 3,
          title: "Website",
          details: "https://personalized-rag-tutor.vercel.app/",
        },
      ],
      ObjectivesHeading: "Objective",
      ObjectivesDetails:
        "An agentic RAG tutoring platform built with LangChain and OpenAI APIs, serving context-aware responses across 10,000+ documents. Reduced average query resolution time by 50% compared to a keyword search baseline. Designed Pinecone vector indexing pipelines achieving 20% better retrieval precision and 200ms inference on a single-node deployment.",
      Technologies: [
        {
          title: "Tools & Technologies",
          techs: ["LangChain", "OpenAI API", "Pinecone", "Python", "RAG"],
        },
      ],
      ProjectDetailsHeading: "Project Details",
      ProjectDetails: [
        {
          id: 1,
          details:
            "An agentic RAG tutoring platform built with LangChain and OpenAI APIs, serving context-aware responses across 10,000+ documents.",
        },
        {
          id: 2,
          details:
            "Reduced average query resolution time by 50% compared to a keyword search baseline.",
        },
        {
          id: 3,
          details:
            "Designed Pinecone vector indexing pipelines achieving 20% better retrieval precision and 200ms inference on a single-node deployment.",
        },
      ],
    },
  },
  {
    ProjectHeader: {
      title: "Multi-Agent AI Sales Automation Platform",
      tags: "AI / Multi-Agent Systems",
    },
    ProjectImages: [
      {
        id: 1,
        title: "Multi-Agent AI Sales Automation Platform",
        img: DeepLearningImg,
      },
    ],
    ProjectInfo: {
      ClientHeading: "Project Type",
      CompanyInfo: [
        {
          id: 1,
          title: "Name",
          details: "Multi-Agent AI Sales Automation Platform",
        },
        {
          id: 2,
          title: "Services",
          details: "AI workflow automation",
        },
      ],
      ObjectivesHeading: "Objective",
      ObjectivesDetails:
        "A multi-agent AI workflow system built with LangGraph, Pydantic, and FastAPI for automated CRM lead qualification, intent classification, and scoring. Reduced manual intervention per lead from 8 minutes to under 1 minute, and scaled the pipeline to handle 5,000+ leads/day using async task queues and fault-tolerant service design.",
      Technologies: [
        {
          title: "Tools & Technologies",
          techs: [
            "LangGraph",
            "Pydantic",
            "FastAPI",
            "Python",
            "Async Queues",
          ],
        },
      ],
      ProjectDetailsHeading: "Project Details",
      ProjectDetails: [
        {
          id: 1,
          details:
            "A multi-agent AI workflow system built with LangGraph, Pydantic, and FastAPI for automated CRM lead qualification, intent classification, and scoring.",
        },
        {
          id: 2,
          details:
            "Reduced manual intervention per lead from 8 minutes to under 1 minute.",
        },
        {
          id: 3,
          details:
            "Scaled the pipeline to handle 5,000+ leads/day using async task queues and fault-tolerant service design.",
        },
      ],
    },
  },
  {
    ProjectHeader: {
      title: "User Centric Web App",
      tags: "UI / Frontend",
    },
    ProjectImages: [
      {
        id: 1,
        title: "User Centric Web App",
        img: UniAccoHomePage,
      },
      {
        id: 2,
        title: "User Centric Web App",
        img: UniAccoListing,
      },
      {
        id: 3,
        title: "User Centric Web App",
        img: UniAccoPropertyDets,
      },
    ],
    ProjectInfo: {
      ClientHeading: "About Client",
      CompanyInfo: [
        {
          id: 1,
          title: "Name",
          details: "UniAcco",
        },
        {
          id: 2,
          title: "Services",
          details: "UI Design & Frontend Development",
        },
        {
          id: 3,
          title: "Website",
          details: "https://uniacco.com",
        },
        {
          id: 4,
          title: "Phone",
          details: "0008000403523",
        },
      ],
      ObjectivesHeading: "Objective",
      ObjectivesDetails:
        "UniAcco aims to simplify the process of finding premium student accommodation. With access to over 10,000 properties across top study destinations like the UK, Canada, Ireland, France, Germany, and more, it helps students secure housing that best fits their needs.",
      Technologies: [
        {
          title: "Tools & Technologies",
          techs: [
            "HTML",
            "Sass",
            "JavaScript",
            "Next.js",
            "React.js",
            "Django",
            "MySQL",
          ],
        },
      ],
      ProjectDetailsHeading: "Challenge",
      ProjectDetails: [
        {
          id: 1,
          details:
            "Gaining proficiency in frameworks like Next.js, especially its server-side rendering (SSR) capabilities.",
        },
        {
          id: 2,
          details:
            "Implementing performance optimizations by refactoring legacy code, adopting clean coding practices, and enhancing Core Web Vitals (such as page load speed and interactivity).",
        },
        {
          id: 3,
          details:
            "Ensuring seamless server-side integration with frontend frameworks like Next.js. Managing scalability and performance bottlenecks, especially during high-traffic periods.",
        },
        {
          id: 4,
          details:
            "Structuring APIs and database queries efficiently to support fast data retrieval and enhance the overall user experience.",
        },
      ],
    },
  },
  {
    ProjectHeader: {
      title: "CRM System",
      tags: "UI / Frontend & Backend",
    },
    ProjectImages: [
      {
        id: 1,
        title: "CRM System",
        img: CRMListingPage,
      },
      {
        id: 2,
        title: "CRM System",
        img: CRMDashboard,
      },
      {
        id: 3,
        title: "CRM System",
        img: CRMConversion,
      },
    ],
    ProjectInfo: {
      ClientHeading: "About Client",
      CompanyInfo: [
        {
          id: 1,
          title: "Name",
          details: "UniAcco | UniCreds | UniScholarz CRM",
        },
        {
          id: 2,
          title: "Services",
          details: "UI Design & Frontend and Backend Development",
        },
      ],
      ObjectivesHeading: "Objective",
      ObjectivesDetails:
        "To create a user-friendly CRM system that streamlines communication and enhances productivity for lead catering.",
      Technologies: [
        {
          title: "Tools & Technologies",
          techs: ["HTML", "CSS", "JavaScript", "React.js", "Django", "MySQL"],
        },
      ],
      ProjectDetailsHeading: "Challenge",
      ProjectDetails: [
        {
          id: 1,
          details:
            "Designed, built, and maintained key modules of the CRM system, improving internal workflows and enhancing user experience for sales and operations teams.",
        },
        {
          id: 2,
          details:
            "Developed and optimized the Conversion Form, a critical revenue-generating component. Refactored legacy code for better performance, ensured data accuracy, and improved user experience leading to higher form submissions and conversion rates.",
        },
        {
          id: 3,
          details:
            "Engineered a Role-Based Access Control (RBAC) system on both frontend and backend, enabling secure, permission-driven user experiences and safeguarding sensitive data based on user roles.Implemented Presigned URL flow across the frontend and backend for secure, time-limited file uploads and downloads—improving scalability and eliminating direct server load from file handling. Automated repetitive CRM processes (e.g., lead tracking, reminders), increasing team efficiency and reducing human error.",
        },
        {
          id: 4,
          details:
            "Integrated external APIs and built dashboards to provide real-time visibility into user behavior, lead data, and team performance metrics. Worked closely with cross-functional teams and built features using React, CSS, Django, and REST APIs, delivering scalable and maintainable CRM solutions.",
        },
      ],
    },
  },
  {
    ProjectHeader: {
      title: "Form Automation Extension",
      tags: "Chrome Extension",
    },
    ProjectImages: [
      {
        id: 1,
        title: "Form Automation Extension",
        img: ManageExtension,
      },
      {
        id: 2,
        title: "Form Automation Extension",
        img: ExtensionUse,
      },
      {
        id: 3,
        title: "Form Automation Extension",
        img: ExtensionWindow,
      },
    ],
    ProjectInfo: {
      ClientHeading: "About Client",
      CompanyInfo: [
        {
          id: 1,
          title: "Name",
          details: "UniAcco | UniScholarz",
        },
        {
          id: 2,
          title: "Services",
          details: "Form Filling Automation",
        },
      ],
      ObjectivesHeading: "Objective",
      ObjectivesDetails:
        "Chrome extension for sales agents to automate form-filling processes and accelerating lead carting by eliminating manual, labor-intensive tasks.",
      Technologies: [
        {
          title: "Tools & Technologies",
          techs: ["HTML", "CSS", "JavaScript", "Jquery"],
        },
      ],
      ProjectDetailsHeading: "Challenge",
      ProjectDetails: [
        {
          id: 1,
          details:
            "Designed and developed a custom Chrome extension to help sales agents automate form-filling tasks during lead carting, drastically reducing manual effort and time spent per lead. Built using HTML, CSS, JavaScript, and jQuery for seamless integration with existing web forms across platforms. Implemented dynamic DOM detection and form field mapping, allowing the extension to autofill data based on user inputs or lead context with high accuracy.",
        },
        {
          id: 2,
          details:
            "Designed logic to handle user input and sensitive data securely with authentication within the extension’s scope, maintaining compliance with data-handling practices. Created a clean, intuitive interface for quick interaction—minimizing friction in the sales workflow and requiring no prior training. Ensured optimized script execution with minimal resource usage to maintain fast browser performance across tabs and sessions.",
        },
        {
          id: 3,
          details:
            "Improved operational efficiency by 75%, reduced lead carting time, and empowered sales agents to focus on closing leads rather than manual data entry.",
        },
      ],
    },
  },
  {
    ProjectHeader: {
      title: "Apperal Generator",
      tags: "Deep Learning Project",
    },
    ProjectImages: [
      {
        id: 1,
        title: "Apperal Generator",
        img: GeneratorImage,
      },
      {
        id: 2,
        title: "Apperal Generator",
        img: GANImage1,
      },
      {
        id: 3,
        title: "Apperal Generator",
        img: GANImage2,
      },
    ],
    ProjectInfo: {
      ObjectivesHeading: "Objective",
      ObjectivesDetails:
        "System that uses apparel images from the dataset to generates new apparels designs using deep learning techniques.",
      Technologies: [
        {
          title: "Tools & Technologies",
          techs: ["Python", "StyleGAN", "TensorFlow", "Keras", "OpenCV"],
        },
      ],
      ProjectDetailsHeading: "Challenge",
      ProjectDetails: [
        {
          id: 1,
          details:
            "Developed a deep learning-based system to automate the creation of apparel designs using Generative Adversarial Networks (GANs)—specifically StyleGAN2 ADA—addressing the time-intensive manual design process in the fashion industry.It uses GANs and RCNNs to spot the pattern blocks of generated apparels. Utilized Python, TensorFlow 1.x, StyleGAN2-ADA, and Google Colaboratory with NVIDIA Tesla K80 GPU for model training.",
        },
        {
          id: 2,
          details:
            "Implemented StyleGAN2 ADA with adaptive discriminator augmentation to enable high-quality image generation even with a limited dataset—ideal given constrained computational resources. Curated and preprocessed datasets from Kaggle (Apparel Dataset) and FEIDEGGER (Fashion Dataset), including dresses and T-shirts with/without models, totaling ~20,000 high-resolution images. Converted image datasets to TFRecords and Configured training with custom parameters (e.g., snapshot intervals, augmentation pipeline, mirror flipping).",
        },
        {
          id: 3,
          details:
            "Trained the GAN for over 20 hours to generate novel apparel designs that were visually distinct from the original dataset, showcasing the ability of the model to synthesize unique, high-resolution clothing patterns. Demonstrated the feasibility of automating fashion design using AI, with potential applications in rapid prototyping, design inspiration, and trend-based collection generation.",
        },
      ],
    },
  },
  {
    ProjectHeader: {
      title: "GVwala Tech",
      tags: "Mobile Application",
    },
    ProjectImages: [
      {
        id: 1,
        title: "Gvwala Tech",
        img: GVwalaTechImg,
      },
      {
        id: 2,
        title: "Gvwala Tech",
        img: GVwalaLoginImg,
      },
      {
        id: 3,
        title: "Gvwala Tech",
        img: GVwalaHomeImg,
      },
    ],
    ProjectInfo: {
      ClientHeading: "About Client",
      CompanyInfo: [
        {
          id: 1,
          title: "Name",
          details: "GVwala Tech",
        },
        {
          id: 2,
          title: "Services",
          details: "Mobile Application Development & Backend Services",
        },
      ],
      ObjectivesHeading: "Objective",
      ObjectivesDetails:
        "Mobile application to sale Gift Cards for various brands and stores.",
      Technologies: [
        {
          title: "Tools & Technologies",
          techs: ["Ionic", "HTML", "CSS", "JavaScript", "Firebase"],
        },
      ],
      ProjectDetailsHeading: "Challenge",
      ProjectDetails: [
        {
          id: 1,
          details:
            "GVwala Tech app is built using the Ionic framework, allowing smooth performance and native-like UI across Android and iOS platforms. Integrated Firebase Authentication for secure login/registration workflows and Firestore for real-time database and data sync. Managing user sessions, authentication state, and real-time updates across different screens using Angular-based state management (e.g., ngRx) introduced architectural complexity.",
        },
        {
          id: 2,
          details:
            "Here, Users can purchase gift cards for themselves or send them to others. Gift cards are categorized by type (e.g., Mobile, Lifestyle, Food), with a clean and searchable interface. Implemented a rewards engine that allows users to redeem points for various gift cards, promoting user engagement. Added a `Wall Feed` section enabling users to post messages, like, comment, and share fostering a social gifting experience within the app.",
        },
        {
          id: 3,
          details:
            "Developed a `Wall of Fame` feature for showcasing top-performing employees (e.g., `Employee of the Month`), reinforcing internal motivation and recognition. Designed an intuitive and mobile-responsive interface using Ionic components, ensuring ease of navigation and modern aesthetics.",
        },
      ],
    },
  },
  {
    ProjectHeader: {
      title: "CleanSweep",
      tags: "Internet Of Things",
    },
    ProjectImages: [
      {
        id: 1,
        title: "CleanSweep",
        img: CleansweepPoster,
      },
      {
        id: 2,
        title: "CleanSweep",
        img: CleansweepImg,
      },
      {
        id: 3,
        title: "CleanSweep",
        img: CleansweepTopImg,
      },
    ],
    ProjectInfo: {
      ObjectivesHeading: "Objective",
      ObjectivesDetails:
        "Autonomous cleaning robot that uses computer vision and machine learning to navigate and clean spaces efficiently.",
      Technologies: [
        {
          title: "Tools & Technologies",
          techs: [
            "Python",
            "Embedded Python",
            "OpenCV",
            "Raspberry Pi",
            "Arduino",
            "Node MCU",
            "ESP8266",
          ],
        },
      ],
      ProjectDetailsHeading: "Challenge",
      ProjectDetails: [
        {
          id: 1,
          details:
            "CleanSweep is an IOT based autonomous smart cleaning robot, aimed at providing a cost-effective, dual-mode solution for efficient floor cleaning addressing the limitations of expensive single-mode cleaning robots in the market. Offers both dry and wet cleaning in a single device, significantly reducing the need for manual labor and overcoming the high cost of commercial cleaning bots.",
        },
        {
          id: 2,
          details:
            "Cleaning Mechanism follows with wet cleaning using rotating brushes and controlled water spray and ends with surface drying using a fan placed underneath. It also consist of Ultrasonic sensors for obstacle detection and avoidance, ensuring safe navigation around furniture and walls. The robot is controlled via a mobile app, allowing users to start, stop, and monitor cleaning sessions remotely.",
        },
        {
          id: 3,
          details:
            "Built a reliable UI that will communicate commands effectively in real time over Bluetooth or Wi-Fi and ensure safety during manual operations.",
        },
      ],
    },
  },
  {
    ProjectHeader: {
      title: "E-commerce platform",
      tags: "Web Application",
    },
    ProjectImages: [
      {
        id: 1,
        title: "E-commerce Websiteplatform",
        img: HandmadeWithLoveLogin,
      },
      {
        id: 2,
        title: "E-commerce Websiteplatform",
        img: HandmadeWithLoveListing,
      },
    ],
    ProjectInfo: {
      ObjectivesHeading: "Objective",
      ObjectivesDetails:
        "E-commerce platform that was designed to sell handcrafted jwellery and accessories.",
      Technologies: [
        {
          title: "Tools & Technologies",
          techs: [
            "HTML",
            "CSS",
            "JavaScript",
            "MySQL",
            "PHP",
            "Bootstrap",
            "Python",
          ],
        },
      ],
      ProjectDetailsHeading: "Challenge",
      ProjectDetails: [
        {
          id: 1,
          details:
            "Built a desktop-based e-commerce platform using Python and PyQt5 for selling handcrafted jewelry and accessories. The application was designed to support small-scale artisans and deliver a smooth, local shopping experience. It features a User Registration & Login with secure password hashing. The platform consist of Product Listing Interface with categorized display of jewelry and accessories, including images, descriptions, and prices. Also consist of Shopping Cart Functionality allowing users to add items, view cart contents, and proceed to checkout.",
        },
        {
          id: 2,
          details:
            "Integrated Razorpay payment gateway for secure online transactions. The application includes an Admin Dashboard for managing products, orders, and user accounts. It also features a Search Functionality to help users find specific products quickly.",
        },
        {
          id: 3,
          details:
            "The platform is built with a focus on user experience, ensuring easy navigation and a responsive design suitable for desktop use.",
        },
      ],
    },
  },
];
